import filters from "./filters/filters";
import LazyLoadingComponent from "../../../common/ts/components/LazyLoadingComponent";
import {connect} from "../../../common/ts/connect";
import pagination from "./pagination/pagination";
import location from "../../../common/ts/core/location";
import dom from "../../../common/ts/core/dom";
import tracking from "../../../common/ts/core/tracking";
import sorting from "./sorting/sorting";
import breadcrumb from "./breadcrumb/breadcrumb";
import emailRetention from "../components/retention/email/main";
import cmpAdsManager from "./cmpAdsManager/cmpAdsManager";
import http from "../../../common/ts/core/http";
import localStorage from "../../../common/ts/core/localStorage";
import notifications from "./notifications/notifications";
import googleOneTap from "./googleOneTap/googleOneTap";
import dfpRightBlock from "../components/dfpRightBlock/dfpRightBlock";
import {FOOTER_SELECTOR, USER_SEARCH_SELECTOR} from "../selectors";
import header from "../components/header/header";
import {EventBus} from "../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import userSearchEventHandlers from "../components/userSearch/eventHandlers";
import {SerpLoadedEvent} from "./events";
import {isDesktopDevice, isMobileDevice} from "../device";
import autocomplete from "./filters/autocomplete";
import {
    FILTER_SEARCH_ID
} from "./filters/constants";
import chips from "./chips";

const FIRST_RIGHT_DFP_SELECTOR = '.js-dfp-right-block__top';
const eventBus = EventBus.getInstance();

export interface MitulaSerpPageData {
    device: string;
    search: string;
    prefix: string;
    text: string;
    shouldShowRetentionCaptureModal: boolean;
    shouldShowProjectSnippet: boolean;
    operationType: string;
    propertyType: string;
    filters: string;
    geoEntity: string;
    pageviewId: string;
    pageNumber: number;
    isPaid: boolean;
    formId: string;
    geoSlug: string;
}

(window as any).initPage = (pageData: MitulaSerpPageData) => {
    connect(() => {
        eventHandlers.init();
        dom.init();
        location.init();
        tracking.init();
        http.init();
        localStorage.init();
        cmpAdsManager.init();
        header.init();
        sorting.init();
        new LazyLoadingComponent().setupLazyLoading();
        filters.init(pageData);
        userSearchEventHandlers.init();
        autocomplete.init({
            id: FILTER_SEARCH_ID,
            ...pageData
        });
        breadcrumb.init();
        pagination.init();
        dfpRightBlock.init({
            topBoundaryElement: dom.select(USER_SEARCH_SELECTOR),
            topSiblingElement: dom.select(FIRST_RIGHT_DFP_SELECTOR),
            bottomBoundaryElement: dom.select(FOOTER_SELECTOR),
        });
        emailRetention.init({
            search: pageData.search,
            pageNumber: pageData.pageNumber,
            isPaid: pageData.isPaid,
            toggleTrackingName: isMobileDevice(pageData.device) ? 'email-retention-bottom-receive-news' : 'email-retention-modal-receive-news',
            submitTrackingName: isMobileDevice(pageData.device) ? 'email-retention-bottom-submit' : 'email-retention-modal-submit',
            isDesktop: isDesktopDevice(pageData.device),
        });
        notifications.init(pageData);
        googleOneTap.init(pageData);
        chips.init();

        eventBus.emit(new SerpLoadedEvent({
            search: pageData.text,
            shouldShowRetentionCaptureModal: pageData.shouldShowRetentionCaptureModal || false,
            shouldShowProjectSnippet: pageData.shouldShowProjectSnippet || false,
            hasPreviousSuggestions: hasPreviousSuggestions(),
            storedSearches: localStorage.getItem("visitedSearches"),
            operationType: pageData.operationType,
            filters: pageData.filters,
            geoEntity: pageData.geoEntity,
            pageviewId: pageData.pageviewId,
            serpUrl: window.location.href,
        }))
    });
}

function hasPreviousSuggestions() {
    const previousSuggestions = dom.selectAll('.email-retention-form__suggestions__inputs__label')
    return previousSuggestions && previousSuggestions.length > 0 || false
}
